import { cn } from "@newxsystems/shared";
import { StratosCommonContent } from "../../../../modules/content/components/StratosCommonContent/StratosCommonContent";
import { StratosRichText } from "../../../../modules/content/components/StratosRichText/StratosRichText";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import type { IStatsBlockProps } from "./StatsBlock.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const StatsBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: IStatsBlockProps) => {
  if (!items?.length) return null;

  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <StratosCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div
          className={cn(
            "grid overflow-hidden rounded-[20px] bg-horizon-blue text-night-flight",
            columns[columnCount || 3],
          )}
        >
          {items.map((item, index) => (
            <article
              className="border-b border-night-flight/15 p-7 sm:border-r sm:p-8 lg:p-10"
              key={index}
            >
              <p className="font-stratos-display text-6xl font-bold leading-[0.85] tracking-[-0.04em] text-night-flight md:text-7xl">
                {item.value}
              </p>
              <h3 className="mt-5 font-stratos-body text-sm font-medium text-foreground">
                {item.label}
              </h3>
              {item.description ? (
                <StratosRichText
                  className="mt-3 max-w-[32ch] text-base text-night-flight/75 md:text-lg"
                  content={item.description}
                />
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </StratosSection>
  );
};

StatsBlock.displayName = "Block::StatsBlock";
